import React, { useCallback } from "react";

import { getNextQueryParams } from "components/helpers";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import ContactService from "services/Contact";
import {
  useReferralContactsTable,
  invalidateReferralContactsQuery,
} from "hooks/useReferralContactsTable";

export const REFERRAL_CONTACTS_TABLE_CONSTANTS = {
  tableName: "referralContacts",
  queryKey: "referral-contacts",
  className: "Contact",
  exportTableName: "ReferralContactsTable",
};

const ReferralContactsTableV3 = ({
  entity_id,
  campaign_id,
  callNextContact,
}) => {
  const { columns } = useReferralContactsTable({
    campaign_id,
    entity_id,
    callNextContact,
    tableName: REFERRAL_CONTACTS_TABLE_CONSTANTS.tableName,
  });

  const defaultQueryParams = { entity_id };

  const fetchReferralContacts = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response = await ContactService.getContacts({
          ...nextQueryParams,
          entity_id,
        });
        return response;
      } catch (error) {
        console.error("Error fetching referral contacts:", error);
        throw error;
      }
    },
    [columns, entity_id]
  );

  return (
    <div style={{ minHeight: "400px", overflow: "auto" }}>
      <BaseTableV3
        columns={columns}
        tableName={REFERRAL_CONTACTS_TABLE_CONSTANTS.tableName}
        queryKey={REFERRAL_CONTACTS_TABLE_CONSTANTS.queryKey}
        className={REFERRAL_CONTACTS_TABLE_CONSTANTS.className}
        defaultFilters={defaultQueryParams}
        fetchData={fetchReferralContacts}
        invalidateData={invalidateReferralContactsQuery}
        enableSearch
      />
    </div>
  );
};

export default ReferralContactsTableV3;
